









import {
    Component, Prop, Vue, Watch,
} from 'vue-property-decorator'
import _ from 'lodash'
import { PropType } from 'vue'
import OpenCardsDueOnDate from '@/components/OpenCardsDueOnDate.vue'
import { TrelloCard, TrelloCardsDueOnDate } from '@/TrelloClient'

@Component({
    components: {
        OpenCardsDueOnDate,
    },
    props: {
        cards: {
            type: Array as PropType<TrelloCard[]>,
            default: [],
        },
    },
})
export default class extends Vue {

    get cardsByDueDate(): TrelloCardsDueOnDate[] {
        let cards: TrelloCard[] = (this as any).cards
        let dates = [...new Set(cards.map(x => x.due))].sort() // unique & sorted due dates
        return dates.map(date => ({
            due: date,
            cards: _.filter(cards, card => (card.due === date)),
        }))
    }

}
